import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {Employee} from 'main/stores/employees';
import _ from 'lodash';

class TimeOffAccountSummary extends DomainObject {
  @observable id;
  @observable employee;
  @observable typeId;
  @observable typeName;
  @observable unlimited;
  @observable workDayLength;
  @observable accrualBalance;
  @observable adjustment = 0;
  @observable adjustBy = 'days';

  @action merge(other) {
    super.merge(other, {
      employee: Employee
    });
  }

  accrued(type) {
    if (this.unlimited) return '--';

    return this.__renderBalance(this.accrualBalance.accrued, type);
  }

  available(type) {
    if (this.unlimited) return '--';

    return this.__renderBalance(this.accrualBalance.available, type);
  }

  used(type) {
    return this.__renderBalance(this.accrualBalance.used, type);
  }

  scheduled(type) {
    return this.__renderBalance(this.accrualBalance.scheduled, type);
  }

  adjustedAvailable(type) {
    if (this.unlimited) return this.available(type);
    if (_.isNaN(parseFloat(this.adjustment))) return this.available(type);

    let adjustment = parseFloat(this.adjustment);
    if (this.adjustByDays && type.unit === 'hours') {
      adjustment *= (this.workDayLength / 3600);
    } else if (!this.adjustByDays && type.unit === 'days') {
      adjustment *= (3600 / this.workDayLength);
    }
    return Math.round((this.available(type) + adjustment) * 100) / 100;
  }

  @computed get adjustmentInHours() {
    return parseFloat(this.adjustment) * 3600 / this.workDayLength;
  }

  @computed get adjustByDays() {
    return this.adjustBy === 'days';
  }

  __renderBalance(seconds, type) {
    if (type.unit === 'days') {
      return Math.round(parseFloat(seconds / this.workDayLength) * 100) / 100;
    } else {
      return Math.round(parseFloat(seconds / 3600) * 100) / 100;
    }
  }
}

export default TimeOffAccountSummary;
